var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-button',_vm._g(_vm._b({staticStyle:{"min-width":"80px"},attrs:{"type":"warning","size":"small"}},'el-button',_vm.$attrs,false),_vm.$listeners),[(_vm.hasIcon)?_c('jj-icons',{attrs:{"type":"export"}}):_vm._e(),_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.text || _vm.$t('buttons.export'))+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }